import * as React from 'react';
import { FormControl, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import { IItem } from './types';

interface IProps {
    rows: IItem[];
    formSectionLabelStyle: React.CSSProperties;
    onJobDescriptionChange: (id: number, additionalWeeksJobDescription: string, weeks: number[]) => void;
}

const ManualLaborJobSection = ({ rows, formSectionLabelStyle, onJobDescriptionChange }: IProps) => {
    if (rows.length === 0) {
        return null;
    }

    return (
        <FormGroup style={{ marginTop: 0, marginBottom: 18 }}>
            <ControlLabel style={formSectionLabelStyle}>Manual labor job description</ControlLabel>
            {rows.map(item => (
                <FormControl
                    key={item.requestId}
                    componentClass='textarea'
                    bsSize='sm'
                    rows={3}
                    placeholder="Describe the donor's job (minimum 5 characters)"
                    maxLength={200}
                    value={item.additionalWeeksJobDescription ?? ''}
                    onChange={(e: React.FormEvent<FormControl & HTMLTextAreaElement>) =>
                        onJobDescriptionChange(item.requestId, e.currentTarget.value, item.weeks)
                    }
                    style={{ maxWidth: '100%', resize: 'vertical' as const, marginTop: 8, borderRadius: 3 }}
                />
            ))}
            <HelpBlock className='text-muted' style={{ marginBottom: 0, marginTop: 6, fontSize: 12 }}>
                At least 5 characters required.
            </HelpBlock>
        </FormGroup>
    );
};

export default ManualLaborJobSection;
